<div class="my-4 mx-5">
    <div class="wrapper mb-5">
        <div class="row align-items-center m-0" style="padding: 10px;">
            <img class="p-2" src="./assets/icons/arrow.svg">
            <span class="label-title ml-2 mr-3">Cartões</span>
            <!-- <button class="action-button ml-2 my-1">Pedir Cartões</button> -->
        </div>
        <div class="row align-items-center m-0">
        </div>
        <div class="component-box container-fluid mb-0 mt-4">
            <div class="container-fluid pt-4">
                <div class="row">
                    <div class="col-12 text-left">
                        <ul class="options-cadastro pl-0">
                            <li>
                                <h5>Detalhes do Pedido: {{ solicitationDetail?.solicitationId }}</h5>
                            </li>
                        </ul>
                    </div>
                </div>

                <table>
                    <tr>
                        <th>Status do Pedido:</th>
                        <td>{{ solicitationDetail?.statusDescription }}</td>
                    </tr>
                    <tr>
                        <th class="pr-3">Quantidade de Cartões:</th>
                        <td>{{ solicitationDetail?.quantityCards }}</td>
                    </tr>
                    <tr>
                        <th>Data de Solicitação:</th>
                        <td>{{ solicitationDetail?.solicitationDate | date: 'dd/MM/yyyy'}}</td>
                    </tr>
                </table>
                <div class="row">

                        <!-- <div class="col text-center">
                            Status do Pedido: Em Analise
                        </div>
                        <div class="col text-center">
                            Quantidade de Cartões: 7
                        </div>
                        <div class="col text-center">
                            Data de Solicitação: 17/09/2021
                        </div> -->

                    <!-- <div class="col-lg-6 col-md-6 col-sm-12 py-2 border-right">
                        <div class="custom-pr-5">
                            <div class="custom-input-container">
                                <div class="custom-p-label">Status do Pedido:</div>
                                <div class="custom-p">Em Analise</div>
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-6 col-md-6 col-sm-12 py-2">
                        <div class="custom-pr-5">
                            <div class="custom-input-container">
                                <div class="custom-p-label">Quantidade de Cartões:</div>
                                <div class="custom-p">7</div>
                            </div>
                        </div>
                    </div> -->

                </div>
                <div class="row pt-4">
                    <div class="col-12">
                        <div class="table-responsive">
                            <table class="list-table table table-striped" id="dataTable" width="100%" cellspacing="0" *ngIf="solicitationDetail">
                                <thead>
                                    <th>Nome</th>
                                    <th>Situação</th>
                                    <th>Quantidade</th>
                                    <th>Data do Pedido</th>
                                    <th>Código de Rastreio</th>
                                    <th>Data de Entrega</th>
                                    <th>Nome do Recebedor</th>
                                    <!-- <th>Cod. Rastreio</th> -->
                                    <th></th>
                                </thead>
                                <tbody class="list-table-row">
                                    <tr class="list-table-cell" *ngFor="let item of solicitationDetail?.solicitationItems">
                                        <!-- | paginate: { itemsPerPage: showItem, currentPage: currentPage, totalItems: totalSolicitations }"> -->
                                        <td>
                                            <span *ngIf="item.personId">{{item.personName ? item.personName : '-'}}</span>
                                            <span *ngIf="item.collaboratorId">{{item.collaboratorName ? item.collaboratorName : '-'}}</span>
                                        </td>
                                        <td>{{item.statusDescription}}</td>
                                        <td>{{item.quantityCards}}</td>
                                        <td>{{item.solicitationDate | date: 'dd/MM/yyyy'}}</td>
                                        <td>{{item.trackingCode ? item.trackingCode : '-'}}</td>
                                        <td>{{item.deliveryDate ? (item.deliveryDate | date: 'dd/MM/yyyy') : '-'}}</td>
                                        <td>{{item.receiverName ? item.receiverName : '-'}}</td>
                                        <td>
                                            <div ngbDropdown class="d-inline-block menu-option custom-context-menu-container" placement="left">
                                                <button class="dropdown-button" id="dropdown-menu" ngbDropdownToggle><img
                                                        src="assets/icons/menu.png" /></button>
                                                <div ngbDropdownMenu aria-labelledby="dropdown-menu" class="p-0 m-0">
                                                    <section class="custom-context-menu">
                                                        <!-- <div ngbDropdownItem (click)="details(item)"><img src="assets/icons/pencil-purple.png" class="mr-2" />Detalhes do pedido</div> -->
                                                        <div ngbDropdownItem (click)="showAddress(ItemAddress, item)">
                                                            <img src="assets/icons/pencil-purple.png" class="mr-2" /> Ver Endereço
                                                        </div>
                                                        <div *ngIf="item.statusId === 1 && solicitationDetail.statusId === 1" ngbDropdownItem (click)="showCancel(cancelmodal,item)">
                                                            <img src="assets/icons/garbage-purple.png" class="mr-2" />Cancelar item do pedido
                                                        </div>
                                                    </section>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            <!-- <div class="page-custom mt-2">
                                <pagination-controls (pageChange)="changePage($event)" responsive="true" previousLabel="" nextLabel=""></pagination-controls>
                            </div> -->
                        </div>

                        <!-- <div *ngIf="totalSolicitations === 0" class="text-center">
                            <h6>
                                Nenhum pedido foi encontrado. Faça um pedido.
                            </h6>
                        </div> -->
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!--Modal de ItemAddress-->
<ng-template #ItemAddress let-modal>
    <div class="col-12 modal-header clean-modal-header">
        <div class="col-md-12">
            <h5 class="modal-title clean-modal-title">
                Endereço
            </h5>
            <p class="clean-modal-subtitle m-3" style="font-size: 20px;">
                {{ address.address }}, {{address.number}} {{address.complement ? ', '+address.complement : ''}} - {{address.neighborhood}}<br>
                {{address.city}} - {{address.uf}} - {{address.cep | cep}}<br>
            </p>
        </div>
    </div>
    <div class="col-12 clean-modal-footer">
        <button class="custom-filter-button button-cancel mr-2" type="button" (click)="modal.dismiss('Close click');navigateToPedidoList()">Fechar</button>
        <!-- <button class="custom-filter-button custom-filter-button-just" type="button" type="button" (click)="cancel(solicitationToCancel);modal.dismiss('Close click')">Sim</button> -->
    </div>
</ng-template>

<!--Modal do Cancelar-->
<ng-template #cancelmodal let-modal>
    <div class="col-12 modal-header clean-modal-header">
        <div class="col-md-12">
            <h5 class="modal-title clean-modal-title">
                Cancelar item do pedido de cartões
            </h5>
            <p class="clean-modal-subtitle" style="font-size: 20px;">
                Tem certeza que deseja cancelar esse item do pedido
                <!-- <span style="color:#313840; font-weight: bold;"> {{solicitationToCancel.solicitationId}}?</span> -->
            </p>
        </div>
    </div>
    <div class="col-12 clean-modal-footer">
        <button class="custom-filter-button button-cancel mr-2" type="button" (click)="modal.dismiss('Close click')">Não</button>
        <button class="custom-filter-button custom-filter-button-just" type="button" type="button" (click)="cancel(solicitationToCancel);modal.dismiss('Close click')">Sim</button>
    </div>
</ng-template>
